//Generated File 
export const AggFATransferRequest = `AggFATransferRequest`;
export const AggrAdditionDeduction = `AggrAdditionDeduction`;
export const AggrFADepreciation = `AggrFADepreciation`;
export const AggrFADisposalDoc = `AggrFADisposalDoc`;
export const AggrFAPropertiesDocument = `AggrFAPropertiesDocument`;
export const AggrFATransferDoc = `AggrFATransferDoc`;
export const CustodyType = `CustodyType`;
export const FAAdditionDeduction = `FAAdditionDeduction`;
export const FACheckListItem = `FACheckListItem`;
export const FAClassification1 = `FAClassification1`;
export const FAClassification2 = `FAClassification2`;
export const FAClassification3 = `FAClassification3`;
export const FAClassification4 = `FAClassification4`;
export const FAClassification5 = `FAClassification5`;
export const FAComponentType = `FAComponentType`;
export const FACreationDoc = `FACreationDoc`;
export const FACustody = `FACustody`;
export const FACustodyDeliveryDoc = `FACustodyDeliveryDoc`;
export const FACustodyDisposal = `FACustodyDisposal`;
export const FACustodyPurchaseDocument = `FACustodyPurchaseDocument`;
export const FACustodyTransferDocument = `FACustodyTransferDocument`;
export const FADeliveryReceiptDoc = `FADeliveryReceiptDoc`;
export const FADepreciation = `FADepreciation`;
export const FADisposalDocument = `FADisposalDocument`;
export const FAFixedAssetsTaking = `FAFixedAssetsTaking`;
export const FAInitialReceipt = `FAInitialReceipt`;
export const FALCCostDoc = `FALCCostDoc`;
export const FALCProformaInvoice = `FALCProformaInvoice`;
export const FALcExpenseDocument = `FALcExpenseDocument`;
export const FALetterOfCredit = `FALetterOfCredit`;
export const FALocation = `FALocation`;
export const FAMaintenanceCheckList = `FAMaintenanceCheckList`;
export const FAMaintenancePlan = `FAMaintenancePlan`;
export const FAMaintenanceRecord = `FAMaintenanceRecord`;
export const FAMaintenanceRecordRequest = `FAMaintenanceRecordRequest`;
export const FAMaintenanceType = `FAMaintenanceType`;
export const FAMovementInDoc = `FAMovementInDoc`;
export const FAMovementOutDoc = `FAMovementOutDoc`;
export const FAOpeningDocument = `FAOpeningDocument`;
export const FAOpeningDocumentUpdate = `FAOpeningDocumentUpdate`;
export const FAPartialDisposalDoc = `FAPartialDisposalDoc`;
export const FAPreventAssetsDeprec = `FAPreventAssetsDeprec`;
export const FAPropertiesDocument = `FAPropertiesDocument`;
export const FAPurchaseDocument = `FAPurchaseDocument`;
export const FAPurchaseOffer = `FAPurchaseOffer`;
export const FAPurchaseOrder = `FAPurchaseOrder`;
export const FAPurchaseRequest = `FAPurchaseRequest`;
export const FAReceiptDoc = `FAReceiptDoc`;
export const FATransferDocument = `FATransferDocument`;
export const FATransferRequest = `FATransferRequest`;
export const FAType = `FAType`;
export const FixedAsset = `FixedAsset`;
